<template>
  <div class="ProgramActivity-detail-page w-100">
    <b-form @submit="handleValidate">
      <b-overlay :show="loading">
        <b-container fluid class="ProgramActivity-list-page__body mb-6 mt-6">
          <b-row>
            <b-col>
              <div class="card card-custom gutter-b w-100">
                <div class="card-body mt-0">
                  <b-row>
                    <!-- Image Section - Left Side -->
                    <b-col
                      cols="3"
                      v-if="
                        ![
                          ActivityEnums.KPI,
                          ActivityEnums.BOOKING,
                          ActivityEnums.SETTINGS,
                        ].includes(this.activityType)
                      "
                    >
                      <img
                        @click="handlePreview(getImageSrc())"
                        :src="getImageSrc()"
                        alt="Activity Image"
                        style="
                          max-width: 100%;
                          height: auto;
                          object-fit: cover;
                          cursor: pointer;
                        "
                        accept=".jpg, .png"
                      />
                      <!-- Modal Preview -->
                      <div
                        v-if="showPreview"
                        class="modal"
                        @click="showPreview = false"
                      >
                        <img :src="previewUrl" class="preview-img" />
                      </div>
                    </b-col>

                    <!-- Form Fields Section - Adjusts width based on image visibility -->
                    <b-col
                      :cols="
                        [
                          ActivityEnums.KPI,
                          ActivityEnums.BOOKING,
                          ActivityEnums.SETTINGS,
                        ].includes(this.activityType)
                          ? 12
                          : 9
                      "
                    >
                      <!-- Row 1: Tên hoạt động, Loại hoạt động -->
                      <b-row>
                        <b-col cols="6">
                          <basic-input
                            label="Tên hoạt động"
                            placeholder="Nhập hoạt động"
                            name="activity"
                            :required="true"
                            :value.sync="Name"
                            v-validate="'required'"
                            :disabled="isViewAlways"
                            data-vv-as="Loại hoạt động"
                            :state="validateState('activity')"
                            :invalidFeedback="errors.first('activity')"
                          ></basic-input>
                        </b-col>
                        <b-col cols="6">
                          <basic-select
                            label="Loại hoạt động"
                            placeholder="Chọn loại hoạt động"
                            name="activityType"
                            data-vv-as="Loại hoạt động"
                            track-by="value"
                            value-label="text"
                            :options="optionsTypes"
                            :value.sync="activityType"
                            :required="true"
                            :disabled="isViewAlways"
                            v-validate="'required'"
                            :state="validateState('activityType')"
                            :invalidFeedback="errors.first('activityType')"
                            @input="
                              ($event) => {
                                selected($event, 'activityType', optionsTypes),
                                  getActivityTypeToFill(activityType);
                              }
                            "
                          />
                        </b-col>
                      </b-row>

                      <!-- Row 2: Level, Detail Link -->
                      <b-row>
                        <b-col cols="4">
                          <basic-select
                            v-if="this.activityType == ActivityEnums.KPI"
                            label="Loại KPI"
                            placeholder="Chọn loại KPI"
                            name="typeKPI"
                            :required="true"
                            v-validate="'required'"
                            :value.sync="detailLink"
                            :disabled="isViewAlways"
                            :options="optionsKPIs"
                            track-by="value"
                            value-label="text"
                            data-vv-as="Loại KPI"
                            :state="validateState('typeKPI')"
                            :invalidFeedback="errors.first('typeKPI')"
                            @input="selected($event, 'typeKPI', optionsKPIs)"
                          />
                          <basic-select
                            v-else-if="
                              this.activityType == ActivityEnums.SETTINGS
                            "
                            label="Loại mục tiêu"
                            placeholder="Chọn loại mục tiêu"
                            :value.sync="detailLink"
                            :disabled="isViewAlways"
                            :options="optionsSettings"
                            track-by="value"
                            value-label="text"
                            name="typeTarget"
                            :required="true"
                            v-validate="'required'"
                            data-vv-as="Loại mục tiêu"
                            :state="validateState('typeTarget')"
                            :invalidFeedback="errors.first('typeTarget')"
                            @input="
                              selected($event, 'typeTarget', optionsSettings)
                            "
                          />
                          <basic-select
                            v-else-if="
                              this.activityType == ActivityEnums.BOOKING
                            "
                            label="Loại đặt hẹn"
                            placeholder="Chọn đặt hẹn"
                            :value.sync="detailLink"
                            :disabled="isViewAlways"
                            :options="optionsBooking"
                            track-by="value"
                            value-label="text"
                            name="bookingType"
                            :required="true"
                            v-validate="'required'"
                            data-vv-as="Loại đặt hẹn"
                            :state="validateState('bookingType')"
                            :invalidFeedback="errors.first('bookingType')"
                            @input="
                              selected($event, 'bookingType', optionsBooking)
                            "
                          />
                          <basic-input
                            v-else
                            label="Detail Link"
                            placeholder="Nhập url hình ảnh format .png or jpg"
                            :value.sync="detailLink"
                            :disabled="isViewAlways"
                          />
                        </b-col>
                        <b-col cols="5">
                          <basic-select
                            label="Cấp độ"
                            placeholder="Chọn cấp độ của hoạt động"
                            track-by="value"
                            value-label="text"
                            :options="optionsLevels"
                            v-model="programActivityLevel"
                            :allow-empty="true"
                            :required="true"
                            name="level"
                            v-validate="'required'"
                            data-vv-as="Cấp độ"
                            :disabled="isViewAlways"
                            :state="validateState('level')"
                            :invalidFeedback="errors.first('level')"
                            @input="selected($event, 'level', optionsLevels)"
                          />
                        </b-col>
                        <b-col cols="3">
                          <basic-input
                            label="Mã"
                            placeholder="Mã"
                            name="code"
                            :value.sync="code"
                            :disabled="isViewAlways"
                          ></basic-input>
                        </b-col>
                      </b-row>

                      <!-- Row 3: Conditional fields based on activity type -->
                      <b-row>
                        <b-col
                          cols="6"
                          v-if="normalizedActivityType === ActivityEnums.SURVEY"
                        >
                          <basic-select
                            label="Bộ khảo sát"
                            placeholder="Chọn bộ khảo sát"
                            :value.sync="surveyId"
                            :disabled="isViewAlways"
                            :options="surveysOptions"
                            track-by="value"
                            value-label="text"
                            :required="true"
                            name="survey"
                            v-validate="'required'"
                            data-vv-as="Cấp độ"
                            :state="validateState('survey')"
                            :invalidFeedback="errors.first('survey')"
                            @input="selected($event, 'survey', surveysOptions)"
                          />
                        </b-col>
                        <b-col
                          cols="6"
                          v-if="normalizedActivityType === ActivityEnums.LESSON"
                        >
                          <basic-select
                            label="Chọn bài học"
                            placeholder="Chọn bài học"
                            :value.sync="lessonId"
                            :disabled="isViewAlways"
                            :options="lessonsOptions"
                            track-by="value"
                            value-label="text"
                            :required="true"
                            name="lesson"
                            v-validate="'required'"
                            data-vv-as="Cấp độ"
                            :state="validateState('lesson')"
                            :invalidFeedback="errors.first('lesson')"
                            @input="selected($event, 'lesson', lessonsOptions)"
                          />
                        </b-col>
                        <b-col
                          cols="6"
                          v-if="normalizedActivityType === ActivityEnums.QUIZZ"
                        >
                          <basic-select
                            label="Chọn Quizz"
                            placeholder="Chọn Quizz"
                            :value.sync="lessonId"
                            :disabled="isViewAlways"
                            :options="quizzOptions"
                            track-by="value"
                            value-label="text"
                            :required="true"
                            name="quizz"
                            v-validate="'required'"
                            data-vv-as="Cấp độ"
                            :state="validateState('quizz')"
                            :invalidFeedback="errors.first('quizz')"
                            @input="selected($event, 'quizz', quizzOptions)"
                          />
                        </b-col>
                        <b-col
                          cols="6"
                          v-if="
                            normalizedActivityType ===
                            ActivityEnums.EDUCATION_RECORD
                          "
                        >
                          <basic-select
                            label="Chọn Record"
                            placeholder="Chọn bản record"
                            :value.sync="lessonId"
                            :disabled="isViewAlways"
                            :options="educationRecordOptions"
                            track-by="value"
                            value-label="text"
                            :required="true"
                            name="record"
                            v-validate="'required'"
                            data-vv-as="Cấp độ"
                            :state="validateState('record')"
                            :invalidFeedback="errors.first('record')"
                            @input="
                              selected($event, 'record', educationRecordOptions)
                            "
                          />
                        </b-col>
                        <b-col
                          cols="6"
                          v-if="
                            normalizedActivityType === ActivityEnums.INFOGRAPHIC
                          "
                        >
                          <basic-select
                            label="Chọn bài học"
                            placeholder="Chọn bài học"
                            :value.sync="lessonId"
                            :disabled="isViewAlways"
                            :options="infographicOptions"
                            track-by="value"
                            value-label="text"
                            :required="true"
                            name="infographic"
                            v-validate="'required'"
                            data-vv-as="Cấp độ"
                            :state="validateState('infographic')"
                            :invalidFeedback="errors.first('infographic')"
                            @input="
                              selected(
                                $event,

                                'infographic',

                                infographicOptions,
                              )
                            "
                          />
                        </b-col>
                      </b-row>

                      <!-- Row 4: Additional configuration fields -->
                      <b-row>
                        <b-col cols="4">
                          <div class="d-flex align-items-center">
                            <basic-input
                              label="Số lần nhắc nhở"
                              placeholder="Số lần nhắc nhở"
                              name="remindersCount"
                              v-model.number="form.RemindersCount"
                              :required="true"
                              :disabled="isViewAlways"
                              v-validate="'required|numeric|min_value:0'"
                              data-vv-as="Số lần nhắc nhở"
                              :state="validateState('remindersCount')"
                              :invalidFeedback="errors.first('remindersCount')"
                              type="number"
                              step="1"
                              min="0"
                              @input="handleRemindersCountChange"
                            ></basic-input>
                            <b-button
                              class="btn btn-success ml-2"
                              style="margin-bottom: 2px"
                              @click="addReminder"
                              :disabled="isView"
                              v-if="!isCreateForm"
                            >
                              <inline-svg
                                class="arrow-icon"
                                :src="`/media/svg/icons/Neolex/Arrows/arrow-top.svg`"
                              />
                            </b-button>
                          </div>
                        </b-col>
                        <b-col cols="4">
                          <basic-input
                            label="Vị trí"
                            placeholder="Vị trí hiển thị"
                            name="displayIndex"
                            type="number"
                            min="1"
                            step="1"
                            v-model="displayIndex"
                            :required="true"
                            :disabled="isViewAlways"
                            v-validate="'required|min_value:1'"
                            data-vv-as="Vị trí hiển thị"
                            :state="validateState('displayIndex')"
                            :invalidFeedback="errors.first('displayIndex')"
                          ></basic-input>
                        </b-col>
                        <b-col cols="4">
                          <basic-select
                            label="Chủ đề"
                            placeholder="Chủ đề"
                            track-by="value"
                            value-label="text"
                            :options="optionsTopics"
                            :value.sync="activityTopic"
                            v-validate="'required'"
                            :required="true"
                            name="activityTopic"
                            data-vv-as="Chủ đề"
                            :disabled="isViewAlways"
                            :state="validateState('activityTopic')"
                            :invalidFeedback="errors.first('activityTopic')"
                            @input="
                              selected($event, 'activityTopic', optionsTopics)
                            "
                          />
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col cols="6">
                          <basic-select
                            label="Số ngày hiển thị hoạt động"
                            placeholder="Chọn số ngày hiển thị hoạt động"
                            name="activityDisplayDay"
                            :options="optionsDays"
                            track-by="value"
                            value-label="text"
                            :value.sync="activityDisplayDay"
                            :required="true"
                            v-validate="'required'"
                            data-vv-as="Số ngày hiển thị hoạt động"
                            :state="validateState('activityDisplayDay')"
                            :invalidFeedback="
                              errors.first('activityDisplayDay')
                            "
                            @input="
                              selected(
                                $event,

                                'activityDisplayDay',

                                optionsDays,
                              )
                            "
                          ></basic-select>
                        </b-col>
                        <b-col cols="6">
                          <basic-select
                            label="Thông báo nhắc nhở"
                            placeholder="Chọn thông báo nhắc nhở"
                            name="allowReminder"
                            :options="optionsReminders"
                            track-by="value"
                            value-label="text"
                            :value.sync="allowReminder"
                            :required="true"
                            v-validate="'required'"
                            data-vv-as="Thông báo nhắc nhở"
                            :state="validateState('allowReminder')"
                            :invalidFeedback="errors.first('allowReminder')"
                            @input="
                              selected(
                                $event,

                                'allowReminder',

                                optionsReminders,
                              )
                            "
                          ></basic-select>
                        </b-col>
                      </b-row>
                    </b-col>
                  </b-row>

                  <!-- Reminder Section -->
                  <b-row
                    class="flex flex-wrap"
                    v-for="(remind, index) in form.remind"
                    :key="remind.id || index"
                    v-if="index < form.RemindersCount"
                    :disabled="isView"
                  >
                    <b-col cols="1">
                      <p style="margin-top: 25px">
                        {{ `Lần ${index + 1}` }}
                      </p>
                    </b-col>
                    <b-col cols="4">
                      <basic-select
                        label="Ngày nhắc nhở"
                        placeholder="Chọn ngày"
                        :name="`reminderNumbers_${index}`"
                        :options="listReminderNumbers"
                        :value.sync="remind.date"
                        track-by="value"
                        value-label="text"
                        :required="form.RemindersCount > 0"
                        v-validate="form.RemindersCount > 0 ? 'required' : ''"
                        :data-vv-as="'Ngày nhắc nhở ' + (index + 1)"
                        :state="validateState(`reminderNumbers_${index}`)"
                        :invalid-feedback="
                          errors.first(`reminderNumbers_${index}`)
                        "
                        @input="handleReminderDateChange($event, index)"
                      />
                    </b-col>
                    <b-col cols="4">
                      <b-form-group
                        :label="'Thời gian nhắc nhở'"
                        :label-for="`ReminderAtTime_${index}`"
                        :state="validateState(`ReminderAtTime_${index}`)"
                        :invalid-feedback="
                          errors.first(`ReminderAtTime_${index}`)
                        "
                      >
                        <template #label>
                          Thời gian nhắc nhở
                          <span
                            v-if="form.RemindersCount > 0"
                            class="text-danger ps-1"
                            >*</span
                          >
                        </template>

                        <b-form-timepicker
                          v-model="remind.time"
                          :name="`ReminderAtTime_${index}`"
                          :required="form.RemindersCount > 0"
                          :disabled="isView"
                          v-validate="form.RemindersCount > 0 ? 'required' : ''"
                          :data-vv-as="'Thời gian nhắc nhở ' + (index + 1)"
                          :class="{
                            'is-invalid': errors.has(`ReminderAtTime_${index}`),
                          }"
                          @input="handleTimeChange($event, index)"
                        />
                      </b-form-group>
                    </b-col>
                    <b-col cols="2">
                      <basic-select
                        label="Phương thức"
                        placeholder="Chọn loại"
                        :name="`ActivityReminderMethod_${index}`"
                        :data-vv-as="'Phương thức ' + (index + 1)"
                        :options="activityOptionsReminders"
                        :value.sync="remind.method"
                        track-by="value"
                        value-label="text"
                        :required="form.RemindersCount > 0"
                        :disabled="isView"
                        :change="ActivityReminderMethod"
                        v-validate="form.RemindersCount > 0 ? 'required' : ''"
                        :state="
                          validateState(`ActivityReminderMethod_${index}`)
                        "
                        :invalid-feedback="
                          errors.first(`ActivityReminderMethod_${index}`)
                        "
                        @input="handleMethodChange($event, index)"
                      ></basic-select>
                    </b-col>
                    <b-col cols="1">
                      <b-button
                        @click="deleteRow(index, remind.id)"
                        :disabled="isView"
                        style="margin-top: 20px"
                        class="bg-danger text-white"
                      >
                        Xóa
                      </b-button>
                    </b-col>
                    <b-col cols="12" class="w-100">
                      <basic-text-editors
                        class="flex"
                        label="Nội dung"
                        placeholder="Nhập nội dung"
                        :name="`reminderContent_${index}`"
                        :required="form.RemindersCount > 0"
                        :disabled="isView"
                        v-model="remind.content"
                        v-validate="form.RemindersCount > 0 ? 'required' : ''"
                        :data-vv-as="'Nội dung nhắc nhở ' + (index + 1)"
                        :state="validateState(`reminderContent_${index}`)"
                        :showEmojiButton="true"
                        :invalidFeedback="
                          errors.first(`reminderContent_${index}`)
                        "
                        @input="handleContentChange($event, index)"
                      />
                    </b-col>
                    <hr
                      v-if="index < form.remind.length - 1"
                      class="w-100 black"
                    />
                  </b-row>
                </div>
                <div class="card-footer d-flex justify-content-end">
                  <b-button
                    class="btn btn-light ml-3"
                    type="button"
                    @click.stop="closeModal"
                  >
                    Hủy
                  </b-button>
                  <b-button
                    class="btn btn-success ml-3"
                    @click.stop="handleValidate"
                    v-if="!isView"
                  >
                    <span class="svg-icon">
                      <inline-svg
                        :src="`/media/svg/icons/Neolex/Basic/${
                          isCreateForm ? 'plus' : 'save'
                        }.svg`"
                      />
                    </span>
                    {{ isCreateForm ? 'Thêm mới' : 'Cập nhật' }}
                  </b-button>
                  <b-button
                    class="btn btn-success ml-3"
                    @click.stop="isView = false"
                    v-if="isView"
                  >
                    <span class="svg-icon">
                      <inline-svg
                        src="/media/svg/icons/Neolex/Basic/save.svg"
                      />
                    </span>
                    Chỉnh sửa
                  </b-button>
                </div>
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-overlay>
    </b-form>
  </div>
</template>

<script>
import { isNull } from 'lodash';
import moment from 'moment';
import 'vue2-datepicker/index.css';
import {
  ActivityEnums,
  LogoDefault,
  optionsKPIs,
  optionsSettings,
  optionsBooking,
  optionsReminders,
  activityoptionsReminders,
} from './ProgramActivityEnums.js';
import { isEmpty } from 'lodash';
export default {
  components: {},
  props: {
    id: {
      type: String,
      default: null,
    },
    form_type: {
      type: String,
      default: 'edit',
    },
    setupData: {
      type: Object,
      default: () => {},
    },
    selectedItem: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      dayReminder: null,
      allowReminder: null,
      code: null,
      showPreview: false,
      previewUrl: '',
      isFetchingSurvey: false,
      name: null,
      activityType: null,
      programActivityLevel: null,
      activityTopic: null,
      activityDisplayDay: null,
      reminderNumbers: null,
      detailLink: null,
      redirectLink: null,
      videoLink: null,
      isView: false,
      isViewAlways: true,
      displayIndex: null,
      surveyId: null,
      lessonId: null,
      color: null,
      ActivityReminderMethod: null,
      optionsKPIs: optionsKPIs,
      optionsSettings: optionsSettings,
      optionsBooking: optionsBooking,
      optionsReminders: optionsReminders,
      activityOptionsReminders: activityoptionsReminders,
      surveysOptions: [],
      lessonsOptions: [],
      quizzOptions: [],
      reminders: [],
      educationRecordOptions: [],
      infographicOptions: [],
      form: {
        RemindersCount: 0,
        remind: [],
      },
      userPackageId: null,
      dateRemindr: null,
      file: null,
      preview: null,
      loading: false,
      activityTopicText: '',
      optionsLevels: [],
      optionsTopics: [],
      optionsTypes: [],
      optionsDays: [],
    };
  },
  created() {},
  computed: {
    ActivityEnums() {
      return ActivityEnums;
    },
    nationId() {
      return this.form.nation?.id;
    },
    provinceId() {
      return this.form.province?.id;
    },
    districtId() {
      return this.form.district?.id;
    },
    isCreateForm() {
      return this.selectedItem.action === 'create';
    },
    isUpdateForm() {
      return this.selectedItem.action === 'view';
    },
    normalizedActivityType() {
      return Array.isArray(this.activityType)
        ? this.activityType[0]?.value || ''
        : this.activityType && typeof this.activityType === 'object'
        ? this.activityType.value
        : this.activityType || '';
    },
  },
  watch: {
    'form.RemindersCount': {
      handler(newValue) {
        if (newValue === '' || newValue === null) {
          this.form.remind = [];
          this.$nextTick(() => {
            this.$validator.validate('remindersCount');
          });
          return;
        }
        if (!Number.isInteger(Number(newValue)) || newValue < 0) {
          this.form.remind = [];
          this.$nextTick(() => {
            this.$validator.validate('remindersCount');
          });
          return;
        }
        const currentReminders = [...this.form.remind];
        this.form.remind = [];
        for (let i = 0; i < newValue; i++) {
          this.form.remind.push(
            currentReminders[i] || {
              id: null,
              date: '',
              time: '',
              content: '',
              method: '',
            },
          );
        }
        this.$nextTick(() => {
          this.$validator.validate('remindersCount');
        });
      },
      immediate: true,
    },
    selectedItem: {
      handler(newVal) {
        this.fillData(newVal);
      },
      deep: true,
      immediate: true,
    },
    normalizedActivityType: {
      handler(activityType) {
        if (!activityType) return;
        if (activityType === ActivityEnums.SURVEY) {
          if (!this.surveysOptions || this.surveysOptions.length === 0) {
            this.getSurveyData();
          }
        } else if (activityType === ActivityEnums.LESSON) {
          if (!this.lessonsOptions || this.lessonsOptions.length === 0) {
            this.getLessonOrQuizzData(1);
          }
        } else if (activityType === ActivityEnums.QUIZZ) {
          if (!this.quizzOptions || this.quizzOptions.length === 0) {
            this.getLessonOrQuizzData(3);
          }
        } else if (activityType === ActivityEnums.EDUCATION_RECORD) {
          if (
            !this.educationRecordOptions ||
            this.educationRecordOptions.length === 0
          ) {
            this.getLessonOrQuizzData(2);
          }
        } else if (activityType === ActivityEnums.INFOGRAPHIC) {
          if (
            !this.infographicOptions ||
            this.infographicOptions.length === 0
          ) {
            this.getLessonOrQuizzData(4);
          }
        }
      },
      immediate: false,
    },
  },
  mounted() {
    this.setupOptions();
  },
  methods: {
    addReminder() {
      this.form.RemindersCount = (this.form.RemindersCount || 0) + 1;
    },

    handleRemindersCountChange(value) {
      this.form.RemindersCount = value;
      this.$nextTick(() => {
        this.$validator.validate('remindersCount');
      });
    },
    getImageSrc() {
      const defaultImage = LogoDefault.ImageDiaB;

      if (this.isCreateForm) {
        return this.detailLink || defaultImage;
      } else {
        return (
          (this.selectedItem && this.selectedItem.detailLink) || defaultImage
        );
      }
    },
    handlePreview(url) {
      this.previewUrl = url;
      this.showPreview = true;
    },
    handleReminderDateChange(value, index) {
      const fieldName = `reminderNumbers_${index}`;
      this.form.remind[index].date = value;
      if (value) {
        this.$validator.reset({ name: fieldName });
        this.$validator.errors.remove(fieldName);
      }
      this.$nextTick(() => {
        this.$validator.validate(fieldName);
      });
      this.selected(value, 'reminderNumbers', this.listReminderNumbers);
    },
    handleTimeChange(value, index) {
      const fieldName = `ReminderAtTime_${index}`;

      this.form.remind[index].time = value;

      if (value) {
        this.$validator.reset({ name: fieldName });

        this.$validator.errors.remove(fieldName);
      }
      this.$nextTick(() => {
        this.$validator.validate(fieldName);
      });
    },
    handleMethodChange(value, index) {
      const fieldName = `ActivityReminderMethod_${index}`;

      this.form.remind[index].method = value;

      if (value) {
        this.$validator.reset({ name: fieldName });
        this.$validator.errors.remove(fieldName);
      }

      this.$nextTick(() => {
        this.$validator.validate(fieldName);
      });

      this.selected(
        value,
        'ActivityReminderMethod',
        this.activityOptionsReminders,
      );
    },
    handleContentChange(value, index) {
      const fieldName = `reminderContent_${index}`;

      this.form.remind[index].content = value;

      if (value && value.trim()) {
        this.$validator.reset({ name: fieldName });

        this.$validator.errors.remove(fieldName);
      }

      this.$nextTick(() => {
        this.$validator.validate(fieldName);
      });
    },
    setupOptions() {
      this.optionsLevels = this.setupData.Levels.map((item) => ({
        value: item.Id,
        text: item.Name,
      }));
      this.optionsTopics = this.setupData.Topics.map((item) => ({
        value: item.Id,
        text: item.Name,
      }));
      this.optionsTypes = this.setupData.Types.map((item) => ({
        value: item.Id,
        text: item.Name,
      }));
      this.optionsDays = this.setupData.Days.map((item) => ({
        value: item.Id,
        text: item.Description,
      }));
      this.optionsDays = this.setupData.Days.map((item) => ({
        value: item.Id,
        text: item.Description,
      }));
    },
    closeModal() {
      this.$emit('close-modal');
    },
    selected(value, formProperty, optionsArr) {
      this.form[formProperty] =
        optionsArr.find((el) => el.value === value) || null;
      this.$validator.reset({ name: formProperty });
      if (this.form[formProperty] || this.form[formProperty]?.value === 0) {
        this.$validator.reset({ name: formProperty });
        this.$validator.errors.remove(formProperty);
        this.$validator.validate(formProperty);
      }
    },
    getRandomHexColor() {
      return (
        '#' +
        Math.floor(Math.random() * 0xffffff)
          .toString(16)
          .padStart(6, '0')
      );
    },
    convertHtmlToNewlines(html) {
      if (!html || typeof html !== 'string') {
        return '';
      }
      let result;
      if (this.isCreateForm) {
        result = html.replace(/<\/p>/gi, '\\n');
      } else {
        const hasPTags = /<p>|<\/p>/gi.test(html);
        result = hasPTags
          ? html.replace(/<\/p>/gi, '\\n')
          : html.replace(/<br\s*\/?>/gi, '\\n');
      }
      result = result.replace(/&nbsp;/g, '');
      result = result.replace(/<[^>]*>/g, '');
      result = result.trim();

      return result;
    },
    convertNewlinesToHtml(text) {
      if (!text || typeof text !== 'string') {
        return text;
      }

      let result = text.replace(/\\n/g, '<br>');

      return result;
    },
    resetData() {
      this.form.code = null;
      this.form.name = null;
      this.form.activityTypeId = null;
      this.form.programActivityLevelId = null;
      this.form.activityTopicId = null;
      this.form.activityDisplayDayId = null;
      this.form.subject = null;
      this.form.reminderNumbers = null;
      this.form.detailLink = null;
      this.form.redirectLink = null;
      this.form.videoLink = null;
      this.form.displayIndex = null;
    },
    notBeforeToday(date) {
      return date > new Date();
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.errors.has(ref);
      }
      return null;
    },
    async returnPage() {
      (await this.handleConfirm())
        ? this.$router.push({
            name: 'program_activity_list',
          })
        : null;
    },
    async handleConfirm() {
      let confirm = await this.$swal({
        text: 'Các thay đổi sẽ không được lưu trữ, bạn có chắc muốn huỷ?',
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Quay lại',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Huỷ',
            value: true,
            visible: true,
            className: 'btn-warning',
            closeModal: true,
          },
        },
      });
      return confirm;
    },
    async handleValidate() {
      let result = await this.$validator.validateAll();
      if (!result) {
        // const errors = this.$validator.errors.items.map((error) => {
        //   return `${error.field}: ${error.msg}`;
        // });
        // this.$toastr.e({
        //   title: 'Lỗi nhập liệu!',
        //   msg:
        //     errors.length > 0
        //       ? `Vui lòng sửa các lỗi sau:\n${errors.join('\n')}`
        //       : 'Vui lòng kiểm tra lại thông tin nhập.',
        // });
        return;
      } else {
        this.submit();
      }
    },
    async deleteRow(index, id) {
      let confirm = await this.$swal({
        text: 'Bạn có chắc muốn xóa nhắc nhở này không?',
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Huỷ',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Xác nhận',
            value: true,
            visible: true,
            className: 'btn-success',
            closeModal: true,
          },
        },
      });

      if (confirm) {
        const dateField = `reminderNumbers_${index}`;
        const timeField = `ReminderAtTime_${index}`;
        const contentField = `reminderContent_${index}`;
        const methodField = `ActivityReminderMethod_${index}`;

        this.$validator.errors.remove(dateField);
        this.$validator.errors.remove(timeField);
        this.$validator.errors.remove(contentField);
        this.$validator.errors.remove(methodField);

        if (isNull(id)) {
          this.form.RemindersCount = this.form.RemindersCount - 1;
          this.form.remind.splice(index, 1);
        } else {
          try {
            this.loading = true;
            await this.$api.delete(`TranProgramActivityReminder/${id}`);
          } catch (error) {
            this.$toastr.e({
              title: 'Lỗi!',
              msg: error,
            });
          } finally {
            this.form.RemindersCount = this.form.RemindersCount - 1;
            this.form.remind.splice(index, 1);
            this.loading = false;
          }
        }

        this.$nextTick(() => {
          for (let i = 0; i < this.form.RemindersCount; i++) {
            this.$validator.reset({ name: `reminderNumbers_${i}` });
            this.$validator.reset({ name: `ReminderAtTime_${i}` });
            this.$validator.reset({ name: `reminderContent_${i}` });
            this.$validator.reset({ name: `ActivityReminderMethod_${i}` });
          }
        });
      }
    },
    fillData(selectedItem) {
      const newItem = selectedItem?.item;
      if (newItem) {
        this.Id = newItem.Id;
        this.Name = newItem.name || 'Chưa đặt tên';
        this.code = newItem.code || '';
        this.form.RemindersCount = newItem.reminderNumbers || 0;
        this.detailLink = newItem.detailLink || '';
        this.redirectLink = newItem.redirectranLink || '';
        this.videoLink = newItem.videoLink || '';
        this.displayIndex = newItem.displayIndex || 0;
        this.userPackageId = newItem.userPackageId || '';

        // Xử lý activity type
        this.activityType = this.setupData.Types.find(
          (type) => type.Id === newItem.activityTypeId,
        )
          ? {
              value: newItem.activityTypeId,
              text: this.setupData.Types.find(
                (type) => type.Id === newItem.activityTypeId,
              ).Name,
            }
          : null;

        // Xử lý program activity level
        this.programActivityLevel = this.setupData.Levels.find(
          (level) => level.Id === newItem.programActivityLevelId,
        )
          ? {
              value: newItem.programActivityLevelId,
              text: this.setupData.Levels.find(
                (level) => level.Id === newItem.programActivityLevelId,
              ).Name,
            }
          : null;

        // Xử lý activity topic
        this.activityTopic = this.setupData.Topics.find(
          (topic) => topic.Id === newItem.activityTopicId,
        )
          ? {
              value: newItem.activityTopicId,
              text: this.setupData.Topics.find(
                (topic) => topic.Id === newItem.activityTopicId,
              ).Name,
            }
          : null;

        // Xử lý activity display day
        this.activityDisplayDay = this.setupData.Days.find(
          (day) => day.Id === newItem.activityDisplayDayId,
        )
          ? {
              value: newItem.activityDisplayDayId,
              text: this.setupData.Days.find(
                (day) => day.Id === newItem.activityDisplayDayId,
              ).Description,
            }
          : null;

        // Xử lý allow reminder
        this.allowReminder =
          newItem.allowReminder != null
            ? {
                value: this.optionsReminders.find(
                  (option) => option.value === newItem.allowReminder,
                ).value,
                text: this.optionsReminders.find(
                  (option) => option.value === newItem.allowReminder,
                ).text,
              }
            : null;

        const activityTypeId = newItem.activityTypeId;

        if (
          activityTypeId === this.ActivityEnums.SURVEY &&
          newItem.surveyId != null
        ) {
          // Load survey options nếu chưa có
          if (this.surveysOptions.length === 0) {
            this.getSurveyData().then(() => {
              this.surveyId = this.surveysOptions.find(
                (survey) => survey.value === newItem.surveyId,
              )
                ? {
                    value: newItem.surveyId,
                    text: this.surveysOptions.find(
                      (survey) => survey.value === newItem.surveyId,
                    ).text,
                  }
                : null;
            });
          } else {
            this.surveyId = this.surveysOptions.find(
              (survey) => survey.value === newItem.surveyId,
            )
              ? {
                  value: newItem.surveyId,
                  text: this.surveysOptions.find(
                    (survey) => survey.value === newItem.surveyId,
                  ).text,
                }
              : null;
          }
        } else if (
          activityTypeId === this.ActivityEnums.LESSON &&
          newItem.lessonId != null
        ) {
          if (this.lessonsOptions.length === 0) {
            this.getLessonOrQuizzData(1).then(() => {
              this.lessonId = this.lessonsOptions.find(
                (lesson) => lesson.value === newItem.lessonId,
              )
                ? {
                    value: newItem.lessonId,
                    text: this.lessonsOptions.find(
                      (lesson) => lesson.value === newItem.lessonId,
                    ).text,
                  }
                : null;
            });
          } else {
            this.lessonId = this.lessonsOptions.find(
              (lesson) => lesson.value === newItem.lessonId,
            )
              ? {
                  value: newItem.lessonId,
                  text: this.lessonsOptions.find(
                    (lesson) => lesson.value === newItem.lessonId,
                  ).text,
                }
              : null;
          }
        } else if (
          activityTypeId === this.ActivityEnums.QUIZZ &&
          newItem.lessonId != null
        ) {
          // Load quizz options nếu chưa có
          if (this.quizzOptions.length === 0) {
            this.getLessonOrQuizzData(3).then(() => {
              this.lessonId = this.quizzOptions.find(
                (quizz) => quizz.value === newItem.lessonId,
              )
                ? {
                    value: newItem.lessonId,
                    text: this.quizzOptions.find(
                      (quizz) => quizz.value === newItem.lessonId,
                    ).text,
                  }
                : null;
            });
          } else {
            this.lessonId = this.quizzOptions.find(
              (quizz) => quizz.value === newItem.lessonId,
            )
              ? {
                  value: newItem.lessonId,
                  text: this.quizzOptions.find(
                    (quizz) => quizz.value === newItem.lessonId,
                  ).text,
                }
              : null;
          }
        } else if (
          activityTypeId === this.ActivityEnums.EDUCATION_RECORD &&
          newItem.lessonId != null
        ) {
          // Load education record options nếu chưa có
          if (this.educationRecordOptions.length === 0) {
            this.getLessonOrQuizzData(2).then(() => {
              this.lessonId = this.educationRecordOptions.find(
                (record) => record.value === newItem.lessonId,
              )
                ? {
                    value: newItem.lessonId,
                    text: this.educationRecordOptions.find(
                      (record) => record.value === newItem.lessonId,
                    ).text,
                  }
                : null;
            });
          } else {
            this.lessonId = this.educationRecordOptions.find(
              (record) => record.value === newItem.lessonId,
            )
              ? {
                  value: newItem.lessonId,
                  text: this.educationRecordOptions.find(
                    (record) => record.value === newItem.lessonId,
                  ).text,
                }
              : null;
          }
        } else if (
          activityTypeId === this.ActivityEnums.INFOGRAPHIC &&
          newItem.lessonId != null
        ) {
          if (this.infographicOptions.length === 0) {
            this.getLessonOrQuizzData(4).then(() => {
              this.lessonId = this.infographicOptions.find(
                (infographic) => infographic.value === newItem.lessonId,
              )
                ? {
                    value: newItem.lessonId,
                    text: this.infographicOptions.find(
                      (infographic) => infographic.value === newItem.lessonId,
                    ).text,
                  }
                : null;
            });
          } else {
            this.lessonId = this.infographicOptions.find(
              (infographic) => infographic.value === newItem.lessonId,
            )
              ? {
                  value: newItem.lessonId,
                  text: this.infographicOptions.find(
                    (infographic) => infographic.value === newItem.lessonId,
                  ).text,
                }
              : null;
          }
        } else {
          this.surveyId = null;
          this.lessonId = null;
        }
        this.listReminderNumbers = this.setupData.ActivityReminders.map(
          (item) => ({
            value: item.Id,
            text: item.Name,
          }),
        );

        this.dateReminder = newItem.tranProgramActivityReminders?.[0]
          ?.reminderTime
          ? moment
              .unix(newItem.tranProgramActivityReminders[0].reminderTime)
              .format('YYYY-MM-DD')
          : '';
        this.reminders = newItem.tranProgramActivityReminders;
        this.form.remind = this.reminders.map((remind) => {
          const selectedDisplayReminders =
            this.setupData.ActivityReminders.find(
              (item) => item.Id === remind.activityReminderId,
            );
          const reminderTime = remind.reminderTime
            ? moment.unix(remind.reminderTime).format('HH:mm:ss')
            : '';
          const reminderDate = remind.reminderTime
            ? moment.unix(remind.reminderTime).format('HH-MM-DD')
            : '';

          return {
            id: remind.id,
            method:
              remind.activityReminderMethod != null
                ? {
                    value: activityoptionsReminders.find(
                      (option) =>
                        option.value === remind.activityReminderMethod,
                    ).value,
                    text: activityoptionsReminders.find(
                      (option) =>
                        option.value === remind.activityReminderMethod,
                    ).text,
                  }
                : null,
            time: reminderTime,
            content: this.convertNewlinesToHtml(remind.reminderContain || ''),
            date: selectedDisplayReminders
              ? {
                  value: selectedDisplayReminders.Id,
                  text: selectedDisplayReminders.Name,
                }
              : null,
            reminderDate: reminderDate,
          };
        });
      } else {
        this.clearData();
      }
    },
    formatDateTime(dayReminder, time) {
      if (!dayReminder || !time) {
        console.error('Thiếu dayReminder hoặc time:', { dayReminder, time });
        return null;
      }

      const dateValue =
        typeof dayReminder === 'object' && dayReminder !== null
          ? dayReminder.value
          : dayReminder;

      if (!moment(dateValue, 'YYYY-MM-DD', true).isValid()) {
        console.error(`Ngày không hợp lệ: ${dateValue}`);
        return null;
      }

      const dateTime = moment(`${dateValue} ${time}`, 'YYYY-MM-DD HH:mm:ss');

      if (!dateTime.isValid()) {
        console.error(`Ngày giờ không hợp lệ: ${dateValue} ${time}`);
        return null;
      }

      return Math.floor(dateTime.valueOf() / 1000);
    },
    async submit() {
      if (
        this.Name == null ||
        this.normalizedActivityType == null ||
        this.programActivityLevel == null ||
        this.activityTopic == null ||
        this.activityDisplayDay == null ||
        this.displayIndex == null
      ) {
        return;
      }
      if (this.form.RemindersCount > 0) {
        for (let reminder of this.form.remind) {
          if (
            !reminder.date ||
            !reminder.time ||
            !reminder.content ||
            !reminder.method
          ) {
            this.$toastr.e({
              title: 'Lỗi!',
              msg: 'Vui lòng nhập đầy đủ thông tin cho các nhắc nhở',
            });
            return;
          }
        }
      }
      let payload = new FormData();
      const isCreateForm = this.isCreateForm;
      const isUpdateForm = this.isUpdateForm;
      payload.append('code', this.code || '');
      payload.append('name', this.Name);
      payload.append('reminderNumbers', this.form.RemindersCount);
      payload.append('DetailLink', this.detailLink || '');
      payload.append('RedirectLink', this.redirectLink || '');
      payload.append('VideoLink', this.videoLink || '');
      payload.append('subject', this.activityTopicText || '');
      payload.append('DisplayIndex', this.displayIndex);
      payload.append('userPackageId', this.userPackageId);

      // if (this.isCreateForm) {
      //   payload.append('color', this.getRandomHexColor());
      // }
      if (this.surveyId) {
        payload.append(
          'surveyId',
          typeof this.surveyId === 'object'
            ? this.surveyId.value
            : this.surveyId,
        );

        if (this.surveyId) {
          payload.append(
            'surveyId',

            typeof this.surveyId === 'object'
              ? this.surveyId.value
              : this.surveyId,
          );
        }
        if (this.lessonId) {
          payload.append(
            'lessonId',

            typeof this.lessonId === 'object'
              ? this.lessonId.value
              : this.lessonId,
          );
        }
      }
      if (this.lessonId) {
        payload.append(
          'lessonId',
          typeof this.lessonId === 'object'
            ? this.lessonId.value
            : this.lessonId,
        );
      }
      payload.append('ActivityTypeId', this.normalizedActivityType);
      payload.append(
        'ProgramActivityLevelId',
        this.programActivityLevel &&
          typeof this.programActivityLevel === 'object'
          ? this.programActivityLevel.value
          : this.programActivityLevel || '',
      );
      payload.append(
        'ActivityTopicId',
        this.activityTopic && typeof this.activityTopic === 'object'
          ? this.activityTopic.value
          : this.activityTopic || '',
      );
      payload.append(
        'ActivityDisplayDayId',
        this.activityDisplayDay && typeof this.activityDisplayDay === 'object'
          ? this.activityDisplayDay.value
          : this.activityDisplayDay || '',
      );
      payload.append(
        'allowReminder',

        typeof this.allowReminder === 'object'
          ? this.allowReminder.value
          : this.allowReminder,
      );

      const Guid = {
        EMPTY: '00000000-0000-0000-0000-000000000000',
      };

      const reminders = this.form.remind
        .slice(0, this.form.RemindersCount)
        .map((reminder) => {
          const convertedContent = this.convertHtmlToNewlines(reminder.content);

          return {
            Id: reminder.id || Guid.EMPTY,
            ReminderContain: convertedContent || '',
            ActivityReminderId:
              typeof reminder.date === 'object' && reminder.date !== null
                ? reminder.date.value
                : reminder.date || '',
            ReminderAtTime: reminder.time || '',
            ActivityReminderMethod:
              typeof reminder.method === 'object' && reminder.method !== null
                ? reminder.method.value
                : reminder.method || '',
          };
        });
      reminders.forEach((reminder, index) => {
        Object.keys(reminder).forEach((key) => {
          payload.append(
            `Reminders[${index}].${key}`,
            reminder[key] ?? Guid.EMPTY,
          );
        });
      });
      let confirm = await this.$swal({
        text: `${
          isCreateForm
            ? 'Bạn có chắc muốn tạo hoạt động này không?'
            : 'Bạn có chắc muốn cập nhật hoạt động này không?'
        }`,
        icon: 'warning',
        buttons: {
          cancel: {
            text: 'Huỷ',
            value: false,
            visible: true,
            className: '',
            closeModal: true,
          },
          confirm: {
            text: 'Xác nhận',
            value: true,
            visible: true,
            className: 'btn-success',
            closeModal: true,
          },
        },
      });
      if (confirm) {
        if (isCreateForm) {
          await this.handleCreate(payload);
        } else if (isUpdateForm) {
          await this.handleUpdate(payload);
        }
      }
    },
    async handleCreate(payload) {
      try {
        this.loading = true;
        await this.$api.post(`TranProgramActivity`, payload);
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Hoạt động đã được tạo!',
        });
        this.$emit('close-modal');
      } catch (e) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Vui lòng kiểm tra lại dữ liệu!',
        });
      } finally {
        this.loading = false;
      }
    },

    async handleUpdate(payload) {
      payload.append('id', this.selectedItem.item.id);
      try {
        this.loading = true;
        await this.$api.put(`TranProgramActivity/id`, payload);
        this.$toastr.s({
          title: 'Thành công!',
          msg: 'Hoạt động đã được cập nhật!',
        });
        this.$emit('close-modal');
      } catch (e) {
        this.$toastr.e({
          title: 'Lỗi!',
          msg: 'Vui lòng kiểm tra lại dữ liệu!',
        });
      } finally {
        this.loading = false;
      }
    },

    clearData() {
      this.Name = '';
      this.code = '';
      this.form = {
        RemindersCount: 0,
        remind: [],
      };
      this.detailLink = '';
      this.redirectLink = '';
      this.videoLink = '';
      this.displayIndex = 0;
      this.surveyId = null;
      this.lessonId = null;
      this.userPackageId = '';
      this.activityType = null;
      this.programActivityLevel = null;
      this.activityTopic = null;
      this.activityDisplayDay = null;
      this.allowReminder = null;
      this.dateReminder = '';
    },
    setupDataExisted(newItem) {
      if (newItem.action === 'view') {
        const reminderCount = newItem.reminders.length;
        this.isViewAlways = true;
        this.isView = true;
        this.Name = this.selectedItem.name;
        this.code = this.selectedItem.code;
        this.activityTopicText = this.selectedItem.subject;
        this.form.RemindersCount = reminderCount || 0;
        this.detailLink = this.selectedItem.detailLink;
        this.redirectLink = this.selectedItem.redirectLink;
        this.videoLink = this.selectedItem.videoLink;
        this.displayIndex = newItem.displayIndex;
        this.surveyId = newItem.surveyId;
        this.lessonId = newItem.lessonId;
        this.userPackageId = newItem.userPackageId;
        this.activityType = this.setupData.Types.find(
          (type) => type.Id === newItem.activityTypeId,
        )
          ? {
              value: newItem.activityTypeId,
              text: this.setupData.Types.find(
                (type) => type.Id === newItem.activityTypeId,
              ).Name,
            }
          : null;
        this.programActivityLevel = this.setupData.Levels.find(
          (level) => level.Id === newItem.programActivityLevelId,
        )
          ? {
              value: newItem.programActivityLevelId,
              text: this.setupData.Levels.find(
                (level) => level.Id === newItem.programActivityLevelId,
              ).Name,
            }
          : null;
        this.activityTopic = this.setupData.Topics.find(
          (topic) => topic.Id === newItem.activityTopicId,
        )
          ? {
              value: newItem.activityTopicId,
              text: this.setupData.Topics.find(
                (topic) => topic.Id === newItem.activityTopicId,
              ).Name,
            }
          : null;
        this.activityDisplayDay = this.setupData.Days.find(
          (day) => day.Id === newItem.activityDisplayDayId,
        )
          ? {
              value: newItem.activityDisplayDayId,
              text: this.setupData.Days.find(
                (day) => day.Id === newItem.activityDisplayDayId,
              ).Description,
            }
          : null;

        this.allowReminder =
          this.selectedItem.allowReminder != null
            ? {
                value: optionsReminders.find(
                  (option) => option.value === this.selectedItem.allowReminder,
                ).value,
                text: optionsReminders.find(
                  (option) => option.value === this.selectedItem.allowReminder,
                ).text,
              }
            : null;
        if (
          newItem.activityTypeId === ActivityEnums.SURVEY &&
          newItem.surveyId != null
        ) {
          if (this.surveysOptions.length === 0) {
            this.getSurveyData().then(() => {
              this.surveyId = this.surveysOptions.find(
                (survey) => survey.value === newItem.surveyId,
              )
                ? {
                    value: newItem.surveyId,
                    text: this.surveysOptions.find(
                      (survey) => survey.value === newItem.surveyId,
                    ).text,
                  }
                : null;
            });
          } else {
            this.surveyId = this.surveysOptions.find(
              (survey) => survey.value === newItem.surveyId,
            )
              ? {
                  value: newItem.surveyId,
                  text: this.surveysOptions.find(
                    (survey) => survey.value === newItem.surveyId,
                  ).text,
                }
              : null;
          }
        } else if (
          newItem.activityTypeId === ActivityEnums.LESSON &&
          newItem.lessonId != null
        ) {
          if (this.lessonsOptions.length === 0) {
            this.getLessonOrQuizzData(1).then(() => {
              this.lessonId = this.lessonsOptions.find(
                (lesson) => lesson.value === newItem.lessonId,
              )
                ? {
                    value: newItem.lessonId,
                    text: this.lessonsOptions.find(
                      (lesson) => lesson.value === newItem.lessonId,
                    ).text,
                  }
                : null;
            });
          } else {
            this.lessonId = this.lessonsOptions.find(
              (lesson) => lesson.value === newItem.lessonId,
            )
              ? {
                  value: newItem.lessonId,
                  text: this.lessonsOptions.find(
                    (lesson) => lesson.value === newItem.lessonId,
                  ).text,
                }
              : null;
          }
        } else if (
          newItem.activityTypeId === ActivityEnums.QUIZZ &&
          newItem.lessonId != null
        ) {
          if (this.quizzOptions.length === 0) {
            this.getLessonOrQuizzData(3).then(() => {
              this.lessonId = this.quizzOptions.find(
                (quizz) => quizz.value === newItem.lessonId,
              )
                ? {
                    value: newItem.lessonId,
                    text: this.quizzOptions.find(
                      (quizz) => quizz.value === newItem.lessonId,
                    ).text,
                  }
                : null;
            });
          } else {
            this.lessonId = this.quizzOptions.find(
              (quizz) => quizz.value === newItem.lessonId,
            )
              ? {
                  value: newItem.lessonId,
                  text: this.quizzOptions.find(
                    (quizz) => quizz.value === newItem.lessonId,
                  ).text,
                }
              : null;
          }
        } else if (
          newItem.activityTypeId === ActivityEnums.EDUCATION_RECORD &&
          newItem.lessonId != null
        ) {
          if (this.educationRecordOptions.length === 0) {
            this.getLessonOrQuizzData(2).then(() => {
              this.lessonId = this.educationRecordOptions.find(
                (record) => record.value === newItem.lessonId,
              )
                ? {
                    value: newItem.lessonId,
                    text: this.educationRecordOptions.find(
                      (record) => record.value === newItem.lessonId,
                    ).text,
                  }
                : null;
            });
          } else {
            this.lessonId = this.educationRecordOptions.find(
              (record) => record.value === newItem.lessonId,
            )
              ? {
                  value: newItem.lessonId,
                  text: this.educationRecordOptions.find(
                    (record) => record.value === newItem.lessonId,
                  ).text,
                }
              : null;
          }
        } else if (
          newItem.activityTypeId === ActivityEnums.INFOGRAPHIC &&
          newItem.lessonId != null
        ) {
          if (this.infographicOptions.length === 0) {
            this.getLessonOrQuizzData(4).then(() => {
              this.lessonId = this.infographicOptions.find(
                (infographic) => infographic.value === newItem.lessonId,
              )
                ? {
                    value: newItem.lessonId,
                    text: this.infographicOptions.find(
                      (infographic) => infographic.value === newItem.lessonId,
                    ).text,
                  }
                : null;
            });
          } else {
            this.lessonId = this.infographicOptions.find(
              (infographic) => infographic.value === newItem.lessonId,
            )
              ? {
                  value: newItem.lessonId,
                  text: this.infographicOptions.find(
                    (infographic) => infographic.value === newItem.lessonId,
                  ).text,
                }
              : null;
          }
        }
        this.dateReminder = newItem.reminders[0].reminderTime
          ? moment.unix(newItem.reminders[0].reminderTime).format('YYYY-MM-DD')
          : '';
        this.form.remind =
          newItem.reminders?.map((reminder) => {
            const selectedDisplayReminders =
              this.setupData.ActivityReminders.find(
                (remind) => remind.Id === reminder.activityReminderId,
              );
            const reminderTime = reminder.reminderTime
              ? moment.unix(reminder.reminderTime).format('HH:mm:ss')
              : '';
            return {
              id: reminder.id,
              date: selectedDisplayReminders
                ? {
                    value: selectedDisplayReminders.Id,
                    text: selectedDisplayReminders.Name,
                  }
                : null,
              time: reminderTime,
              content: this.convertNewlinesToHtml(reminder.reminderContain),
              method:
                reminder.activityReminderMethod != null
                  ? {
                      value: activityoptionsReminders.find(
                        (option) =>
                          option.value === reminder.activityReminderMethod,
                      ).value,
                      text: activityoptionsReminders.find(
                        (option) =>
                          option.value === reminder.activityReminderMethod,
                      ).text,
                    }
                  : null,
            };
          }) || [];
      } else {
        this.clearData();
      }
    },
    async getActivityTypeToFill(id) {
      if (isEmpty(id)) return;
      if (Object.values(this.ActivityEnums).includes(id)) {
        return;
      } else {
        try {
          this.loading = true;
          const activityType = typeof id === 'object' ? id.value : id;

          const { data } = await this.$api.get(`ActivityType/${activityType}`);
          this.detailLink = data.preDetailLink || '';
          this.redirectLink = data.preRedirectLink || '';
          this.form.RemindersCount = data.preReminderNumber || 0;
          const level = this.setupData.Levels.find(
            (l) => l.Id === data.preLevel,
          );
          this.programActivityLevel = level
            ? { value: level.Id, text: level.Name }
            : { value: '', text: '' };
          const reminders = JSON.parse(data.preReminderContain) || [];
          const currentReminders = [...this.form.remind];
          this.form.remind = [];
          const targetCount = this.form.RemindersCount;
          for (let i = 0; i < targetCount; i++) {
            const apiReminder = reminders[i] || {
              date: '',
              time: '',
              content: '',
            };
            const existingReminder = currentReminders[i] || {
              id: null,
              date: '',
              time: '',
              content: '',
            };
            const activityReminder = this.setupData.ActivityReminders.find(
              (ar) =>
                ar.Id ===
                (existingReminder.date?.value ||
                  existingReminder.date ||
                  apiReminder.date),
            );
            this.form.remind.push({
              id: existingReminder.id || null,
              date: activityReminder
                ? { value: activityReminder.Id, text: activityReminder.Name }
                : {
                    value:
                      apiReminder.date || existingReminder.date?.value || '',
                    text: '',
                  },
              time: existingReminder.time || apiReminder.time || '',
              content: this.convertNewlinesToHtml(
                existingReminder.content || apiReminder.content || '',
              ),
            });
          }
        } catch (error) {
          this.$toastr.e({
            title: 'Lỗi!',
            msg: error.message || 'Không thể tải dữ liệu loại hoạt động',
          });
        } finally {
          this.lessonId = null;

          this.surveyId = null;

          this.$validator.reset({ name: 'survey' });

          this.$validator.reset({ name: 'lesson' });

          this.$validator.reset({ name: 'quizz' });

          this.$validator.reset({ name: 'record' });

          this.$validator.reset({ name: 'infographic' });

          this.$nextTick(() => {
            this.$validator.validate('survey');

            this.$validator.validate('lesson');

            this.$validator.validate('quizz');

            this.$validator.validate('record');

            this.$validator.validate('infographic');
          });
          this.loading = false;
        }
      }
    },
    async getSurveyData() {
      this.loading = true;
      const response = await this.$api.get(
        `/Survey?page=1&size=1000&isCoach=false`,
      );
      this.loading = false;
      if (response.meta.success === true) {
        this.surveysOptions = response.data.map((survey) => ({
          value: survey.id,
          text: survey.name,
        }));
        this.$toastr.s({
          title: 'Survey!',
          msg: 'Lấy dữ liệu khảo sát thành công!',
        });
      } else {
        this.$toastr.e({
          title: 'Survey!',
          msg: 'Lấy dữ liệu khảo sát thất bại',
        });
      }
    },
    async getLessonOrQuizzData(classify) {
      this.loading = true;
      let lessonTypes = null;
      const originalClassify = classify;

      if (classify === 2) {
        lessonTypes = [2];
      } else {
        const lessonTypeValue = classify === 3 ? 1 : classify;
        lessonTypes = [lessonTypeValue, 2];
      }

      const queryString = lessonTypes
        .map((type) => `IncludeLessonType=${type}`)
        .join('&');
      const url =
        originalClassify === 3
          ? `/Lesson?page=1&size=1000&${queryString}&lessonStateId=1&code=${encodeURIComponent(
              'Q',
            )}`
          : `/Lesson?page=1&size=1000&${queryString}&lessonStateId=1`;

      const response = await this.$api.get(url);
      this.loading = false;

      if (response.meta.success === true) {
        const options = response.data.map((item) => ({
          value: item.id,
          text: item.name,
          code: item.code,
        }));
        if (originalClassify === 1) {
          this.lessonsOptions = options;
        } else if (originalClassify === 3) {
          this.quizzOptions = options.filter((item) =>
            item.code.toLowerCase().startsWith('q'),
          );
        } else if (originalClassify === 2) {
          this.educationRecordOptions = options;
        } else if (originalClassify === 4) {
          this.infographicOptions = options;
        }
        this.$toastr.s({
          title: 'Lesson!',
          msg: 'Lấy dữ liệu bài học thành công!',
        });
      } else {
        this.$toastr.e({
          title: 'Lesson!',
          msg: 'Lấy dữ liệu bài học thất bại!',
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.pictureInput {
  position: relative;
}
.arrow-icon {
  height: 22px;
}

.icon-edit {
  z-index: 100;
  position: absolute;
  top: -15px;
  right: -6px;
  padding: 2px 6px;
  box-shadow: -1px 2px 10px rgba(0, 0, 0, 0.2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  width: fit-content;
  background-color: #fff;
}
.aterisk {
  color: #f64e60;
  font-size: 0.9rem;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  cursor: zoom-out;
}

.preview-img {
  max-width: 90vw;
  max-height: 90vh;
  border-radius: 8px;
}
</style>
